<template>
    <div>

        <v-btn text @click="mostrarDialogo=true" small class="success my-2">Agregar Usuario</v-btn>
        <v-dialog v-model="mostrarDialogo" max-width="600px">
        <v-card>

            <v-card-title>
                <h3>Agregar un nuevo usuario</h3>
            </v-card-title>

            <v-spacer vertical></v-spacer>

            <v-card-text>

              <v-form 
              v-model="Valido" 
              class ="px-3 my-3" >

                <v-text-field label="Usuario" v-model="usuario" 
                clearable required :rules="[(v) => !!v || 'obligatorio']" />

                <v-text-field label="Nombre/s" v-model="nombre" 
                required maxlength="50" counter 
                :rules="[reglasUsuario.required,reglasUsuario.contador]" />

                <v-text-field label="Apellido Paterno" v-model="paterno" 
                required maxlength="50" counter 
                :rules="[reglasUsuario.required,reglasUsuario.contador]" />

                <v-text-field label="Apellido Materno" v-model="materno"
                required maxlength="50" counter 
                :rules="[reglasUsuario.required,reglasUsuario.contador]" />

                <v-text-field label="Correo" v-model="correo"
                required
                :rules="emailRules" />

                <label class="d-flex justify-center text-body-1 text--primary">Asignar Roles</label>
                <v-row class="d-flex justify-space-around pa-0">
                  <v-col cols="12" sm="6" md="6" v-for="rol in rolesCheckboxes" :key="rol.ROL_ID" >
                    <v-checkbox v-model="rolesUsuario" :label="rol.DESCRIPCION" :value="rol.ROL_ID" hide-details="" class=""/>
                  </v-col>
                </v-row>

                <v-text-field label="Contraseña" v-model="contrasena1" 
                required type="password" />
                <v-text-field label="Confirmar Contraseña" v-model="contrasena2" 
                required type="password" />

                <v-alert v-if="error" class="red lighten-3 d-flex justify-center">
                  <span class="text--white">Las contraseñas no coinciden.</span>
                </v-alert>

                <div class="d-flex justify-center">
                  <v-btn class="mx-2 mt-3" 
                  dark 
                  @click="mostrarDialogo = !mostrarDialogo"> 
                    Cancelar 
                  </v-btn>
                  <v-btn class="success darken-1 mx-2 mt-3" @click="btnAgregarUsuario" :disabled="!Valido"><span> Agregar usuario </span></v-btn>

                </div>

              </v-form>
            </v-card-text>

        </v-card>
    </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
export default {

    // -----------------------------------------------------------------------
    data() {
        return {
    
            mostrarDialogo: false,
            Valido:true,
            error:false,
            rolesCheckboxes:[],

            usuario:"",
            nombre:"",
            paterno:"",
            materno:"",
            rolesUsuario:[],
            contrasena1:"",
            contrasena2:"",
            correo:"",

            reglasUsuario:{
              required:(v) => !!v || "Obligatorio",
              contador: (v) => v.length <= 50 || "Maximo 50 caracteres."
            },

            emailRules: [ v => /.+@.+/.test(v) || 'Invalid Email address' ]
            
        }
    },

    // -----------------------------------------------------------------------
    computed: {
      ...mapGetters(['getURLAPI','getUsuario']),

      fechaActual(){
            const d = new Date;
            var fecha = [ d.getFullYear(),
                        d.getMonth()+1,
                        d.getDate()].join('-')+' '+
                       [d.getHours(),
                        d.getMinutes(),
                        d.getSeconds()].join(':');

            return fecha;
        },
    },

    // -----------------------------------------------------------------------
    methods: {

      btnAgregarUsuario(){
        if (this.rolesUsuario.length > 0) {
          
        if ( this.contrasena1 == this.contrasena2){

        const nuevoUsuario = {
          "NOMBRE":               this.nombre.toUpperCase(),
          "APELLIDO_P":           this.paterno.toUpperCase(),
          "APELLIDO_M":           this.materno.toUpperCase(),
          "USUARIO":              this.usuario.toUpperCase(),
          "PASS":                 this.contrasena1,
          "ESTATUS":              'A',
          "TIPO_ID":              1,
          "ROL_ID":               this.rolesUsuario,
          "CORREO":               this.correo,
          // "USUARIO_CREADOR":      this.nombre.toUpperCase(),
          "USUARIO_CREADOR":      this.getUsuario,
          "FECHA_HORA_CREACION":  this.fechaActual,
        };

        axios.post(`${this.getURLAPI}/Usuarios/insert`, nuevoUsuario)
        .then( (res) =>{
          console.log(res.data);
          
        // '$emit' Ejecuta el metodo declarado en el componente 'padre'
        // en este caso el padre es 'Usuarios.vue'
          if (res.data.STATUS == 'OK') {
              this.usuario = '';
              this.nombre = '';
              this.paterno = '';
              this.materno = '';
              this.rolesUsuario = [];
              this.contrasena1 = "";
              this.contrasena2 = "";
              this.correo = "";
              this.$emit( 'actualizarTabla' );
              this.$root.vtoast.show(
                { message: res.data.MSG, color: res.data.STATUS=='OK' ? 'success darken-2':'red darken-2', 
                  timer:10000, icon: res.data.STATUS=='OK' ? 'mdi-check':'mdi-alert-circle-outline' } 
              )
              // this.$emit( 'mostrarSnackbar', res.data ); // Se adjunta con argumentos
              this.mostrarDialogo = false;
            }
        })
        .catch(
          (err) =>{
            console.log(err);
            this.$root.vtoast.show(
            { message: "Error al conectar con el servidor.", color: 'red darken-2', 
              timer:5000, icon: 'mdi-alert-circle-outline' } 
          )
          }
        )
        } else {
          this.error = true;
        }
        }else{
          this.$root.vtoast.show(
            { message: "Se necesita asignar al menos un 'Rol' al usuario", color: 'black', 
              timer:5000, icon: 'mdi-alert-circle-outline' } 
          )
        }
      },

      // mostrarRoles(){
      //   console.log(this.rolesUsuario);
      // }
      

    // -----------------------------------------------------------------------
    },
    async created() {
      this.error =          false;
      this.mostrarDialogo = false;
      this.Valido =         true;
      this.error =          false;
      this.usuario =        "";
      this.nombre =         "";
      this.paterno =        "";
      this.materno =        "";
      this.contrasena1 =    "";
      this.contrasena2 =    "";
      this.rolesCheckboxes = ( await axios.get(`${this.getURLAPI}/Show/allRol` ) ).data

      console.log(this.rolesCheckboxes);
    },
}
</script>

<style>

</style>